import React, { useState, useEffect, useCallback } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Menu,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Select,
  Stack
} from "@mui/material";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import NotificationsOffIcon from "@mui/icons-material/NotificationsOff";
import { signInWithGoogle, userLogout } from "../services/authService";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";
import { addGame, addEncounter, getTeams, getEncounters, addTeam,subscribeToPush, unsubscribeFromPush, isUserSubscribed } from "../services/firestoreService";
import { Link } from "react-router-dom";

const Header = ({ user, role, updatePastEncounters }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [email, setEmail] = useState("");
  const [player1, setPlayer1] = useState("");
  const [player2, setPlayer2] = useState("");
  const [selectedEncounter, setSelectedEncounter] = useState("");
  const [team1, setTeam1] = useState("");
  const [team2, setTeam2] = useState("");
  const [date, setDate] = useState("");
  const [teams, setTeams] = useState([]);
  const [encounters, setEncounters] = useState([]);
  const [newTeam, setNewTeam] = useState("");
  const [pastEncounters, setPastEncounters] = useState([]);
  const [isSubscribed, setIsSubscribed] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const teamsData = await getTeams();
      setTeams(teamsData);
      const encountersData = await getEncounters();
      setEncounters(encountersData);
    };

    fetchData();
  }, []);

  const openGameDialog = useCallback((type) => {
    setDialogType(type);
    setOpenDialog(true);
  }, []);

  useEffect(() => {
    window.openGameDialog = openGameDialog;
  }, [openGameDialog]);

  
  const fetchPastEncounters = async () => {
    try {
      const encountersData = await getEncounters();
      const teamsData = await getTeams();
      const now = new Date();
      const cutoff = new Date(now.getTime() - 48 * 60 * 60 * 1000);

      const pastEncounters = encountersData
        .filter(encounter => new Date(encounter.date) < cutoff)
        .map(encounter => ({
          ...encounter,
          team1Name: teamsData.find(team => team.id === encounter.team1)?.name || "Unbekannt",
          team2Name: teamsData.find(team => team.id === encounter.team2)?.name || "Unbekannt",
          date: new Date(encounter.date),
        }));

      setPastEncounters(pastEncounters);
    } catch (error) {
      console.error("Fehler beim Abrufen vergangener Begegnungen:", error);
    }
  };

  useEffect(() => {
    fetchPastEncounters();
  }, []);

  useEffect(() => {
    if (updatePastEncounters) {
      updatePastEncounters(() => fetchPastEncounters);
    }
  }, [updatePastEncounters]);

  useEffect(() => {
    const checkSubscription = async () => {
      if (user) {
        const subscribed = await isUserSubscribed(user.uid);
        setIsSubscribed(subscribed);
      }
    };
    checkSubscription();
  }, [user]);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogOpen = (type) => {
    setDialogType(type);
    setOpenDialog(true);
    handleClose();
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setEmail("");
    setPlayer1("");
    setPlayer2("");
    setSelectedEncounter("");
    setTeam1("");
    setTeam2("");
    setDate("");
    setNewTeam("");
  };

  const handleAddGame = async () => {
    if (player1 && player2 && selectedEncounter) {
      try {
        await addGame(player1, player2, selectedEncounter);
        setPlayer1("");
        setPlayer2("");
        setSelectedEncounter("");
        handleDialogClose();
      } catch (error) {
        console.error("Fehler beim Hinzufügen des Spiels:", error);
      }
    } else {
      alert("Bitte alle Felder ausfüllen.");
    }
  };

  const handleAddEncounter = async () => {
    if (team1 && team2 && date) {
      await addEncounter(team1, team2, date);
      handleDialogClose();
    } else {
      alert("Bitte alle Felder ausfüllen.");
    }
  };

  const handleAddTeam = async () => {
    if (newTeam) {
      await addTeam(newTeam);
      setTeams([...teams, { id: newTeam, name: newTeam }]);
      setNewTeam("");
    }
  };

  const handleToggleSubscription = async () => {
    if (!user) return;

    if (isSubscribed) {
      await unsubscribeFromPush(user.uid);
      setIsSubscribed(false);
    } else {
      const subscribed = await subscribeToPush(user.uid);
      setIsSubscribed(subscribed);
    }
  };
  return (
    <AppBar position="static">
    <Toolbar>
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        <Button component={Link} to="/" variant="h6" color="inherit">
          HTC Live Match
        </Button>
      </Typography>

      {user ? (
        
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="body1">{user.displayName || user.email}</Typography>
            {/* 🔔 Push-Button */}
            <IconButton color="inherit" onClick={handleToggleSubscription}>
              {isSubscribed ? <NotificationsActiveIcon /> : <NotificationsOffIcon />}
            </IconButton>

          <Button color="inherit" onClick={handleMenuClick}>Menü</Button>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
            {role === "admin" && (
              <>
                <MenuItem disabled>Admin-Bereich</MenuItem>
                <MenuItem onClick={() => handleDialogOpen("game")}>Spiel hinzufügen</MenuItem>
                <MenuItem onClick={() => handleDialogOpen("encounter")}>Begegnung hinzufügen</MenuItem>
                <MenuItem onClick={() => handleDialogOpen("team")}>Mannschaft hinzufügen</MenuItem>
                <MenuItem component={Link} to="/admin">Rollenverwaltung</MenuItem>
                <MenuItem component={Link} to="/settings">Settings</MenuItem>
                <MenuItem disabled>Vergangene Begegnungen</MenuItem>
              </>
            )}
            {pastEncounters.length > 0 ? (
              pastEncounters.map((encounter) => (
                <MenuItem key={encounter.id} component={Link} to="/past-encounters">
                  {`${encounter.team1Name} vs ${encounter.team2Name} (${encounter.date.toLocaleDateString()})`}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>Keine vergangenen Begegnungen</MenuItem>
            )}
            <MenuItem onClick={userLogout}>Logout</MenuItem>
          </Menu>
        </Stack>
      ) : (
        <Button component={Link} to="/login" color="inherit">
          Login
        </Button>
      )}
    </Toolbar>

    <Dialog open={openDialog} onClose={handleDialogClose}>
      <DialogTitle>
        {dialogType === "game" ? "Neues Spiel hinzufügen" :
          dialogType === "encounter" ? "Neue Begegnung hinzufügen" :
            dialogType === "team" ? "Neue Mannschaft hinzufügen" : "Login"}
      </DialogTitle>
      <DialogContent>
        {dialogType === "team" && (
          <>
            <TextField label="Mannschaftsname" fullWidth value={newTeam} onChange={(e) => setNewTeam(e.target.value)} sx={{ mb: 2 }} />
            <Button onClick={handleAddTeam} color="primary">Hinzufügen</Button>
          </>
        )}
        {dialogType === "encounter" && (
          <>
            <Select fullWidth value={team1} onChange={(e) => setTeam1(e.target.value)} sx={{ mb: 2 }}>
              {teams.map((team) => (
                <MenuItem key={team.id} value={team.id}>{team.name}</MenuItem>
              ))}
            </Select>
            <Select fullWidth value={team2} onChange={(e) => setTeam2(e.target.value)} sx={{ mb: 2 }}>
              {teams.map((team) => (
                <MenuItem key={team.id} value={team.id}>{team.name}</MenuItem>
              ))}
            </Select>
            <TextField label="Datum" type="date" fullWidth value={date} onChange={(e) => setDate(e.target.value)} sx={{ mb: 2 }} />
            <Button onClick={handleAddEncounter} color="primary">Begegnung hinzufügen</Button>
          </>
        )}
          {dialogType === "game" && (
            <>
              <TextField label="Spieler 1" fullWidth value={player1} onChange={(e) => setPlayer1(e.target.value)} sx={{ mb: 2 }} />
              <TextField label="Spieler 2" fullWidth value={player2} onChange={(e) => setPlayer2(e.target.value)} sx={{ mb: 2 }} />
              <Select
                fullWidth
                value={selectedEncounter}
                onChange={(e) => setSelectedEncounter(e.target.value)}
                sx={{ mb: 2 }}
              >
                {encounters.map((encounter) => (
                  <MenuItem key={encounter.id} value={encounter.id}>
                    {`${teams.find(team => team.id === encounter.team1)?.name || "Team 1"} vs ${teams.find(team => team.id === encounter.team2)?.name || "Team 2"}`}
                  </MenuItem>
                ))}
              </Select>

              <Button onClick={handleAddGame} color="primary">Spiel hinzufügen</Button>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">Abbrechen</Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );
};

export default Header;


